import React, { memo, useCallback, useEffect, useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import InfoIcon from "@mui/icons-material/Info";
import PowerIcon from "@mui/icons-material/Power";
import SearchIcon from "@mui/icons-material/Search";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import {
  Checkbox,
  Collapse,
  Divider,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import Pagination from "@mui/material/Pagination";
import DriverScore from "Utilities/DriverScorePopup";
import { Fragment } from "react";
import { useSelector } from "react-redux";
import noData from "./../../assets/img/no-data.png";

import PropTypes from "prop-types";
import dayjs from "dayjs";

const EnhancedTableHead=React.memo((props) =>{
  const { sort, setSort, parentProp, checkForColumns } = props;

  const Text = ({ content }) => {
    return (
      <p
        style={{
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          overflow: "hidden",
          fontWeight: "600",
          color: "#B3B4B6",
          textTransform: "capitalize",
        }}
      >
        {content}
      </p>
    );
  };


  const handleSort = (key) => {
    setSort((prevSortState) => {
      return {
        ...prevSortState,
        [key]: !prevSortState[key] ? 1 : prevSortState[key] == 1 ? -1 : 0
      }
    })
  }

  return (
    <TableHead>
      <TableRow>
        {parentProp.columns.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align}
            sortDirection={sort && sort?.[headCell.id] == 1 ? 'asc' : -1 ? 'desc' : false}
            style={
              headCell.label == "Name" && parentProp.sticky
                ? {
                    position: "sticky",
                    left: 0,
                    background: "white",
                    zIndex: 800,
                  }
                : {}
            }
          >
            {sort && sort[headCell.id] !== undefined ? (
              <TableSortLabel
                onClick={() => handleSort(headCell.id)}
                IconComponent={
                  sort[headCell.id] == 1
                    ? () => (
                        <ArrowDropDownIcon
                          sx={{
                            cursor: "pointer",
                            color: "grey",
                          }}
                        />
                      )
                    : sort[headCell.id] == -1
                    ? () => (
                        <ArrowDropUpIcon
                          sx={{
                            cursor: "pointer",
                            color: "grey",
                          }}
                        />
                      )
                    : () => (
                        <SwapVertIcon sx={{ color: "#999", fontSize: 13 }} />
                      )
                }
              >
                <Text content={headCell.label} />
              </TableSortLabel>
            ) : (
             headCell.label=="html"? parentProp.htmlLabel() : <Text content={headCell.label} />
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
})

EnhancedTableHead.propTypes = {
  sort: PropTypes.any.isRequired,
  setSort: PropTypes.func.isRequired,
  parentProp: PropTypes.any.isRequired,
  checkForColumns:PropTypes.func.isRequired
};

const EnhancedTable = ({props})=> {
  // useEffect(()=>console.log("Table re render"),[])


  const colouredPillsStyling={
    borderRadius:'15px',
    width:'6vw',
    lineHeight:'4vh',
    height:'4vh'
  }

  const totalPages = props.totalPages;
  const totalDocuments = props.totalDocuments;
  const pageSize = props.pageSize;

  const metaDataValue = useSelector((state) => state.metaData);

  const checkboxLabel = { inputProps: { "aria-label": "Checkbox demo" } };
  const [columnLengths, setColumnLengths] = useState({});
  const [priorityIndex,setPriorityIndex]=useState()
  const [statusIndex,setStatusIndex]=useState()

  let priorities = [
    {
      name: "CRITICAL",
      color: "#bf3535",
      fade: "rgb(191,53,53,0.1)",
    },
    {
      name: "MAJOR",
      color: "#844204",
      fade: "rgb(132,66,4,0.1)",
    },
    {
      name: "MINOR",
      color: "#fe9f1b",
      fade: "rgb(254,160,60,0.1)",
    },
    {
      name: "WARNING",
      color: "#3399ff",
      fade: "rgb(66,161,255,0.1)",
    },
  ];
  let statuses = [
    {
      name: "CLEARED",
      color: "#bf3535",
      fade: "rgb(191,53,53,0.1)",
    },
    {
      name: "ACKNOWLEDGED",
      color: "#3399ff",
      fade: "rgb(66,161,255,0.1)",
    },
    {
      name: "ACTIVE",
      color: "#5fb762",
      fade: "rgb(95,183,98,0.1)",
    },
  ];

  useEffect(()=>{
    if(props?.columns){
      props.columns.forEach((column,index)=>{
        if(column.label=='Priority'){
          setPriorityIndex(index)
        }
        if(column.label=='Status'){
          setStatusIndex(index)
        }
      })
    }
  },[props?.columns])

  useEffect(() => {
    let newObj = {};
    props?.expandedDevices &&
      props.expandedDevices.forEach((id) => {
        const found = props.rows.find((row) => row.id == id);
        if (found && found?.childDevices?.length) {
          let columns = props.generateColumns(found.childDevices);
          newObj[id] = columns.length;
        }
      });
    setColumnLengths(newObj);
  }, [props?.expandedDevices]);


  function arrayUnique(array) {
    var a = array.concat();
    for (var i = 0; i < a.length; ++i) {
      for (var j = i + 1; j < a.length; ++j) {
        if (a[i] === a[j]) a.splice(j--, 1);
      }
    }
    return a;
  }

  function itemGenerator(array, x = 0, temp = [], end = false) {
    var a = array.concat();
    if (a.length == 1) return a[0];
    for (var i = 1; i < a.length; ++i) {
      if (end) {
        temp = arrayUnique(temp.concat(a[x]));
        i = a.length;
      } else {
        temp = arrayUnique(temp.concat(arrayUnique(a[x].concat(a[x + 1]))));
      }
      x += 2;
      if (x >= a.length - 1) {
        if (a.length % 2 == 0) {
          i = a.length;
        } else {
          end = true;
        }
      }
    }
    return temp;
  }

  const handleSearch = (e) => {
    let target = e.target.value.toLowerCase();
    setFilterFn({
      fn: (items) => {
        if (target == "") return items;
        else {
          var temp = [];
          props.filter.forEach((elm) => {
            temp.push(
              items.filter((x) => x[elm]?.toLowerCase().includes(target))
            );
          });
          return itemGenerator(temp);
        }
      },
    });
  };

  const checkForColumns = useCallback((column)=> {
    return (
      column.label == "Name" ||
      column.label == "Serial Number" ||
      column.label == "IMEI" ||
      column.label == "Firmware" ||
      column.label == "Last Updated" ||
      column.label == "connectivity" ||
      column.label == "Last Message" ||
      column.label == "Created At" ||
      column.label == "Updated At" ||
      column.label == "Asset" ||
      column.label == "Repeated"
    );
  },[])


  const sortDate = (label, value) => {
    if (label == 'Created At' || label == 'Updated At') {

      // const originalFormat = 'MM/DD/YYYY HH:mm:ss ';
      // const targetFormat = 'DD/MM/YYYY hh:mm:ss ';
      // console.log("value is",value)
      // const convertedDate = dayjs(value, { format: originalFormat }).format(targetFormat);
      // if(convertedDate!='Invalid Date')
      //   return convertedDate
      // else 
      //   return convertedDate

      const dateObj = new Date(value);

      // Check if parsing was successful (returns Invalid Date if not)
      if (dateObj instanceof Date && !isNaN(dateObj)) {
        // Format the date object according to the desired format
        return dateObj.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }) + ' ' + dateObj.toLocaleTimeString('en-GB', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true // Include AM/PM indicator
        });
      } else {
        // console.log('parsing failed')
        // If parsing fails, return the original value
        return value;
      }
    }
    else if (label == 'Last Message') {
      // const targetFormat = 'DD/MM/YYYY hh:mm:ss A';
      // value = value.replace('-', ' ')
      // const [date, time] = value.split(' ')
      // const [hour] = time.split(':')
      // const hourPadded = hour.padStart(2, '0')
      // value = value.replace(hour, hourPadded)
      // console.log("value is",value)
      // const convertedDate = dayjs(value, 'DD/MM/YYYY HH:mm:ss A').format(targetFormat)
      // console.log('converted Date',convertedDate)
      // if(convertedDate!='Invalid Date')
      //   return convertedDate
      // else 
      //   return convertedDate


      const dateObj = new Date(value);

      // Check if parsing was successful (returns Invalid Date if not)
      if (dateObj instanceof Date && !isNaN(dateObj)) {
        // Format the date object according to the desired format
        return dateObj.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }) + ' ' + dateObj.toLocaleTimeString('en-GB', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true // Include AM/PM indicator
        });
      } else {
        // console.log('parsing failed')
        // If parsing fails, return the original value
        return value;
      }

    }
    else {
      return value
    }
  }

  function selectAsset(row) {
    let index = props.assets.findIndex((a) => a.internalId == row.internalId);
    if (index != -1) {
      let temp = [...props.assets];
      temp.splice(index, 1);
      props.setAssets(temp);
    } else {
      const found = props.unattachedDevices?.find(
        (d) => d.internalId == row.internalId
      );
      if (!found) return;
      props.setAssets([...props.assets, { ...row, _id: found._id }]);
    }
  }

  function descendingComparator(a, b, orderBy) {
    // console.log('descendingComparator')
    if (orderBy == 'lastUpdated') {
      const formatA = (a[orderBy].includes('A') || a[orderBy].includes('P')) ? 'DD/MM/YYYY HH:mm:ss A' : 'DD/MM/YYYY hh:mm:ss'
      const formatB = (b[orderBy].includes('A') || b[orderBy].includes('P')) ? 'DD/MM/YYYY HH:mm:ss A' : 'DD/MM/YYYY hh:mm:ss'
      let valueA
      let valueB
      const targetFormat = 'DD/MM/YYYY hh:mm:ss ';
      if (formatA == 'DD/MM/YYYY HH:mm:ss A') {
        valueA = a[orderBy]
        valueA = valueA.replace('-', ' ')
        const [date, time] = valueA.split(' ')
        const [hour] = time.split(':')
        const hourPadded = hour.padStart(2, '0')
        valueA = valueA.replace(hour, hourPadded)
        valueA = dayjs(valueA, 'DD/MM/YYYY HH:mm:ss A')
      }
      if (formatB == 'DD/MM/YYYY HH:mm:ss A') {
        valueB = b[orderBy]
        valueB = valueB.replace('-', ' ')
        const [date, time] = valueB.split(' ')
        const [hour] = time.split(':')
        const hourPadded = hour.padStart(2, '0')
        valueB = valueB.replace(hour, hourPadded)
        valueB = dayjs(valueB, 'DD/MM/YYYY HH:mm:ss A')
      }
      return valueB.diff(valueA)
    } else {
      const valueA = a[orderBy]?.toString()?.toLowerCase();
      const valueB = b[orderBy]?.toString()?.toLowerCase();
      return valueB?.localeCompare(valueA);
    }
  }



  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }


  const handleChangePage = (event, newPage) => {
    props.handleChange(newPage)
  };

  const handleCheckboxClick = (row) => {
    const newState = { ...checkedState, [row.internalId]: !checkedState[row.internalId] };
    // console.log("newState: ", newState);
    setCheckedState(newState);
    // console.log("Checkbox row", row);
    props.selectDevice(row);
  };

  const [checkedState, setCheckedState] = useState({});

  // console.log("props.rows: ", props.rows);
  useEffect(() => {
    // Merge each visible row's isChild into checkedState, preserving any
    // prior entries (e.g., rows from other paginated pages that aren't
    // currently rendered). This keeps checkboxes in sync when the user
    // navigates pages or when props.rows change for any other reason.
    setCheckedState((prev) => {
      const next = { ...prev };
      props.rows.forEach((row) => {
        next[row.internalId] = row.isChild;
      });
      return next;
    });
  }, [props.rows]);
  

  return (
    <div
      style={{
        minWidth: props.minWidth ? props.minWidth : "",
        overflowX: props.overflowX ? props.overflowX : "",
        // fill: take the height the parent's flex layout gives, so the table
        // scrolls inside it and the pager stays in view
        ...(props.fill && {
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
        }),
      }}
    >
      {props.rows.length == 0 ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            paddingBottom: "40px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "200px",
              width: "200px",
            }}
          >
            <img style={{ maxWidth: "70%", maxHeight: "70%" }} src={noData} />
          </div>
          <p style={{ color: "#c8c8c8" }}>No data found</p>
        </div>
      ) : (
        <Fragment>
          {props.search ? (
            <TextField
              variant="outlined"
              fullWidth
              size="small"
              label="Search"
              onChange={handleSearch}
              style={{ marginBottom: "10px" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon style={{ color: "grey" }} />
                  </InputAdornment>
                ),
              }}
            />
          ) : null}
          <TableContainer
            sx={{
              minHeight: props.minHeight ? props.minHeight : "400px",
              height: props.height,
              ...(props.fill && { flex: 1, minHeight: 0 }),
            }}
          >
            <Table
              stickyHeader
              size="small"
              style={{
                width: "100%",
              }}
            >
              <EnhancedTableHead
                sort={props?.sort}
                setSort={props?.setSort}
                parentProp={props}
                checkForColumns={checkForColumns}
              />
              <TableBody>
                {props.rows.map((row, rowIndex) => {
                  // the caller's panel for this row (or null), shown in the second row
                  const expanded = props.renderExpanded
                    ? props.renderExpanded(row)
                    : null;
                  return (
                    <Fragment key={(row.html && row.html._id) || row.internalId || row.id || rowIndex}>
                      <TableRow
                        role="checkbox"
                        tabIndex={-1}
                        // opt-in whole-row click (the Alarms Dashboard opens a row's history),
                        // with the hover highlight; other tables pass nothing (2026-10-30)
                        hover={!!props.onRowClick}
                        onClick={props.onRowClick ? () => props.onRowClick(row) : undefined}
                        sx={{
                          cursor: props.onRowClick ? "pointer" : undefined,
                          // cursor: props.groupAsset && "pointer",
                          /* backgroundColor:
                            props.groupAsset &&
                            props.assets.find(
                              (a) => a.internalId == row.internalId
                            ) &&
                            metaDataValue.branding.secondaryColor, */
                        }}
                        // onClick={() => props.groupAsset && selectAsset(row)}
                      >
                        {props.columns.map((column,index) => {
                          const value = row[column.id];
                          if (column.id == "html") {
                            return (
                              <TableCell
                                style={
                                  props.sticky
                                    ? {
                                        position: "sticky",
                                        left: 0,
                                        background: "white",
                                      }
                                    : {}
                                }
                                key={column.id}
                                align={column.align}
                              >
                                {props.html(row)}
                              </TableCell>
                            );
                          } else if (column.id == "html2") {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {props.html2(row)}
                              </TableCell>
                            );
                          } else if (column.id == "assetType") {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {row?.assetImage !== "NA" ? <img
                                    style={{ maxWidth: "2.5rem" }}
                                    src={row?.assetImage}
                                  /> : null}
                                  {row?.assetType !== "NA" ? <span
                                    style={{
                                      whiteSpace: "nowrap",
                                      marginLeft: "0.5rem",
                                    }}
                                  >
                                    {row.assetType}
                                  </span> : <span style={{color: "rgb(85,85,85)", margin: "0 auto", fontWeight: "bold", fontSize: "11px"}}>No Defined Type</span>}
                                </div>
                              </TableCell>
                            );
                          } else if (column.id == "html3") {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {props.html3(row)}
                              </TableCell>
                            );
                          } 
                          else if (column.id == "isChild") {
                            return (
                              <TableCell
                                key={column.id}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Checkbox
                                    key={row.internalId}
                                    checked={checkedState[row.internalId] ? "checked": ""}
                                    {...checkboxLabel}
                                    onClick={() => handleCheckboxClick(row)}
                                  />
                                </div>
                              </TableCell>
                            );
                          } else if (
                            column.id == "email" ||
                            column.id == "actuations"
                          ) 
                          {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {props.icon(row, column.id)}
                              </TableCell>
                            );
                          } else if(column.id == "heirarchy"){
                            return(
                              <TableCell key={column.id} align={column.align}>
                                <span style={{whiteSpace: "nowrap"}}>
                                  {row?.parentDevice ? `Child of ${row.parentDevice.name}` : row?.childDevices.length ? `${row.childDevices.length} ${row.childDevices.length === 1 ? 'Child Device' : 'Child Devices'}` : "No Heirarchy"}
                                </span>
                              </TableCell>
                            )
                          } else {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                <p
                                  style={{
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                    maxWidth: "30vw",
                                    backgroundColor: (index === priorityIndex) ? (
                                      priorities.find((priority) => priority.name === value)?.fade || 'initial'
                                    ) :(index === statusIndex) ? (
                                      statuses.find((status) => status.name === value)?.fade || 'initial'
                                    )  : 'initial',                                      
                                    color: (index === priorityIndex) ? (
                                      priorities.find((priority) => priority.name === value)?.color || 'initial'
                                    ) :(index === statusIndex) ? (
                                      statuses.find((status) => status.name === value)?.color || 'initial'
                                    )  : 'initial',

                                    ...(index === priorityIndex || index === statusIndex) && { ...colouredPillsStyling }

                                    // borderRadius:


                                  }}
                                >
                                  {column.format && typeof value === "number" ?
                                    sortDate(column.label,column.format(
                                      value
                                    ))
                                  : sortDate(column.label,value)}
                                </p>
                              </TableCell>
                            );
                          }
                        })}
                      </TableRow>
                      <TableRow>
                        {expanded ? (
                          <TableCell
                            colSpan={props.columns.length}
                            // no line of its own: a closed panel takes no space (2026-10-30)
                            style={{ padding: 0, borderBottom: "none" }}
                          >
                            {expanded}
                          </TableCell>
                        ) : null}
                        {props.showHeirarchy && props.expandedDevices && props?.expandedDevices?.includes(row.id) ? (
                          <TableCell
                            style={{ paddingBottom: 0, paddingTop: 0 }}
                            colSpan={columnLengths[row.id] || 20}
                          >
                            <Collapse
                              in={props.expandedDevices ? props?.expandedDevices?.includes(row.id) : false}
                              timeout="auto"
                              unmountOnExit
                            >
                                <Table style={{ margin: 1, marginLeft: "20px" }}>
                                  <TableHead>
                                    <TableRow
                                      sx={{ backgroundColor: "#C0C0C0" }}
                                    >
                                      {props
                                        .generateColumns(row.childDevices)
                                        .map((column) => (
                                          <TableCell
                                            key={column.id}
                                            align={column.align}
                                            sx={
                                              props.sticky
                                                ? {
                                                    backgroundColor:
                                                      "#C0C0C0",
                                                  }
                                                : {}
                                            }
                                            style={
                                              column.label == "Name" &&
                                              props.sticky
                                                ? {
                                                    position: "sticky",
                                                    left: 0,
                                                    zIndex: 800,
                                                  }
                                                : {}
                                            }
                                          >
                                            {column.label ==
                                            "connectivity" ? (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  color: "",
                                                  position: "relative",
                                                  cursor:
                                                    checkForColumns(column) &&
                                                    "pointer",
                                                }}
                                              >
                                                <PowerIcon />
                                              </div>
                                            ) : column.label == "html" ? (
                                              props.htmlLabel()
                                            ) : (
                                              <p
                                                style={{
                                                  whiteSpace: "nowrap",
                                                  textOverflow: "ellipsis",
                                                  overflow: "hidden",
                                                  fontWeight: "600",
                                                  color: "white",
                                                  textTransform: "capitalize",
                                                  cursor:
                                                    checkForColumns(column) &&
                                                    "pointer",
                                                }}
                                              >
                                                {column.label}
                                                {column.label ==
                                                "Driver Score" ? (
                                                  <span
                                                    style={{
                                                      cursor: "pointer",
                                                      margin: "10px",
                                                    }}
                                                    onClick={() =>
                                                      setOpenDriverPopup(true)
                                                    }
                                                  >
                                                    <InfoIcon
                                                      style={{
                                                        width: "15px",
                                                        height: "15px",
                                                        position: "absolute",
                                                        top: "11px",
                                                        color: "grey",
                                                      }}
                                                    />
                                                  </span>
                                                ) : null}
                                              </p>
                                            )}
                                          </TableCell>
                                        ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody
                                    sx={{ backgroundColor: "#E5E4E2" }}
                                  >
                                    {row.childDevices.map((device) => {
                                      if (typeof device == "object") {
                                        let formattedDevice = props.formatDevice(
                                          device
                                        );
                                        return (
                                          <TableRow
                                            role="checkbox"
                                            tabIndex={-1}
                                            sx={{
                                              cursor:
                                                props.groupAsset && "pointer",
                                              backgroundColor:
                                                props.groupAsset &&
                                                props.assets.find(
                                                  (a) =>
                                                    a.internalId ==
                                                    formattedDevice.internalId
                                                ) &&
                                                metaDataValue.branding
                                                  .secondaryColor,
                                            }}
                                            onClick={() =>
                                              props.groupAsset &&
                                              selectAsset(formattedDevice)
                                            }
                                          >
                                            {props
                                              .generateColumns(
                                                row.childDevices
                                              )
                                              .map((column) => {
                                                const value =
                                                  formattedDevice[column.id];
                                                if (column.id == "html") {
                                                  return (
                                                    <TableCell
                                                      style={
                                                        props.sticky
                                                          ? {
                                                              position:
                                                                "sticky",
                                                              left: 0,
                                                              background:
                                                                "#E5E4E2",
                                                            }
                                                          : {}
                                                      }
                                                      key={column.id}
                                                      align={column.align}
                                                    >
                                                      {props.html(
                                                        formattedDevice
                                                      )}
                                                    </TableCell>
                                                  );
                                                } else if (
                                                  column.id == "html2"
                                                ) {
                                                  return (
                                                    <TableCell
                                                      key={column.id}
                                                      align={column.align}
                                                    >
                                                      {props.html2(
                                                        formattedDevice
                                                      )}
                                                    </TableCell>
                                                  );
                                                } else if (
                                                  column.id == "assetType"
                                                ) {
                                                  return (
                                                    <TableCell
                                                      key={column.id}
                                                      align={column.align}
                                                    >
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "center",
                                                        }}
                                                      >
                                                        <img
                                                          style={{
                                                            maxWidth:
                                                              "2.5rem",
                                                          }}
                                                          src={
                                                            formattedDevice?.assetImage
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            whiteSpace:
                                                              "nowrap",
                                                            marginLeft:
                                                              "0.5rem",
                                                          }}
                                                        >
                                                          {
                                                            formattedDevice.assetType
                                                          }
                                                        </span>
                                                      </div>
                                                    </TableCell>
                                                  );
                                                } else if (
                                                  column.id == "html3"
                                                ) {
                                                  return (
                                                    <TableCell
                                                      key={column.id}
                                                      align={column.align}
                                                    >
                                                      {props.html3(
                                                        formattedDevice
                                                      )}
                                                    </TableCell>
                                                  );
                                                } else if (
                                                  column.id == "email" ||
                                                  column.id == "actuations"
                                                ) {
                                                  return (
                                                    <TableCell
                                                      key={column.id}
                                                      align={column.align}
                                                    >
                                                      {props.icon(
                                                        formattedDevice,
                                                        column.id
                                                      )}
                                                    </TableCell>
                                                  );
                                                } else if(column.id == "heirarchy"){
                                                  return(
                                                    <TableCell key={column.id} align={column.align}>
                                                      <span style={{whiteSpace: "nowrap"}}>
                                                        {`Child of ${row.html}`}
                                                      </span>
                                                    </TableCell>
                                                  )
                                                }else {
                                                  return (
                                                    <TableCell
                                                      key={column.id}
                                                      align={column.align}
                                                    >
                                                      <p
                                                        style={{
                                                          whiteSpace:
                                                            "nowrap",
                                                          textOverflow:
                                                            "ellipsis",
                                                          overflow: "hidden",
                                                          maxWidth: "30vw",
                                                        }}
                                                      >
                                                        {column.format &&
                                                        typeof value ===
                                                          "number"
                                                          ? sortDate(column.label,column.format(
                                                              value
                                                            ))
                                                          : sortDate(column.label,value)}
                                                      </p>
                                                    </TableCell>
                                                  );
                                                }
                                              })}
                                          </TableRow>
                                        );
                                      }
                                    })}
                                  </TableBody>
                                </Table>
                              </Collapse>
                            </TableCell>
                          ) : null}
                        </TableRow>
                      </Fragment>
                    );
                  })}
                </TableBody>
              </Table>
          </TableContainer>
          <Divider />
          <div
            style={{
              margin: props.paginationMargin
                ? props.paginationMargin
                : "2vh 5vw",
              width: "100%",
              display: "flex",
              gap: "2vw",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {props.setPageSize ? (
              <FormControl size="small">
                <Select
                  value={props.pageSize}
                  onChange={
                    (e) => {
                      handleChangePage(e, 1)
                      props.setPageSize(e.target.value)
                    }
                  }
                  // style={{
                  //   padding: "5px 30px 5px 10px"
                  // }}
                >
                  {(props.pageSizeOptions || [10, 20, 30, 40, 50]).map((size) => (
                    <MenuItem key={size} value={size}>{size}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : null}
            <Pagination
              color="secondary"
              count={totalPages}
              page={props.page}
              onChange={handleChangePage}
            />
            <p style={{color:'#808080'}}>
              {((props.page-1) * (pageSize)) + 1}
              - {props.page == totalPages ? totalDocuments : (props.page * pageSize)}
              {typeof totalDocuments === "number" ? ` of ${totalDocuments}` : null}
              {/* {props.page == totalPages
                ? props.page * pageSize +(totalDocuments - props.page * pageSize)
                : props.page * pageSize}{" "}
              - {totalDocuments} */}
            </p>
          </div>
        </Fragment>
      )}
    </div>
  );
}

function TableParent(props) {
 
  const [open, setOpen] = React.useState(false);
  const [openDriverPopup, setOpenDriverPopup] = React.useState(false);


  // console.log("praps",props)



  return (
    <Fragment>
      <Fragment>
        {openDriverPopup ? (
          <DriverScore setOpen={(v) => setOpenDriverPopup(v)} />
        ) : null}
      </Fragment>
      {open ? (
        <Dialog fullScreen open transitionDuration={0.3}>
          <EnhancedTable props={props} />
        </Dialog>
      ) : (
        <EnhancedTable props={props} />
      )}
    </Fragment>
  );
}

export default memo(TableParent);
